import { Observable } from "rxjs";
export function skipSync() {
    return (source) => new Observable((subscriber) => {
        let subscribed = false;
        const subscription = source.subscribe((value) => subscribed && subscriber.next(value), subscriber.error.bind(subscriber), subscriber.complete.bind(subscriber));
        subscribed = true;
        return subscription;
    });
}
//# sourceMappingURL=skipSync.js.map